/** @file QUAD_HANDLE_METRICS: the quad handles' sizes in CSS px (drawn and grabbed at any zoom). */

/** `square` resize handle side, `diamond` pivot diagonal, `marker` parent-end diagonal, `border` dark rim, `grab` hit radius. */
export const QUAD_HANDLE_METRICS = { square: 8, diamond: 12, marker: 8, border: 2, grab: 7 } as const;
